import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGame } from "../header/GameContext";
import { ANSWERS_DATA } from "./quizData";

import ButtonOnly from "../button/buttonOnly";

function QuizeCheck({ answerData, onWrong }) {
  const navigate = useNavigate();

  const { isFinalQuiz, correctCount, setCorrectCount } = useGame();

  const [value, setValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const isActive = value.trim().length > 0;

  // 문자열 정규화 (공백 제거 + 소문자)
  const normalize = (str) => str.replace(/\s+/g, "").toLowerCase();

  const handleSubmit = () => {
    setIsLoading(true); // 로딩 시작

    const QUIZ = ANSWERS_DATA[answerData];

    // q1, q2 자체가 없을 때
    if (!QUIZ) {
      onWrong?.();
      return;
    }

    const input = normalize(value);

    // answer를 항상 배열로 변환
    const answers = Array.isArray(QUIZ.answer) ? QUIZ.answer : [QUIZ.answer];

    // 정답 비교
    const isCorrect = answers.some((ans) => normalize(ans) === input);

    // ❌ 오답 처리
    if (!isCorrect) {
      if (isFinalQuiz(answerData)) {
        navigate("/wrong", {
          state: {
            nextState: {
              route: QUIZ.next.route,
              answerData: QUIZ.next.answerData,
              DateVal: QUIZ.next.DateVal,
              titImgClass: QUIZ.next.titImgClass,
            },
            message: "추론이 틀린 것 같아...<br/>다음 문제를 풀어보자.", // 오답 문구
          },
        });
      } else {
        onWrong?.();
      }
      setIsLoading(false); // 실패 시 로딩 해제
      return;
    }

    if (isFinalQuiz(answerData)) {
      setCorrectCount((prev) => prev + 1);
    }

    // ✅ 정답 → 다음 페이지 이동
    navigate(QUIZ.next.route, {
      state: {
        answerData: QUIZ.next.answerData,
        DateVal: QUIZ.next.DateVal,
        titImgClass: QUIZ.next.titImgClass,
      },
    });
  };

  return (
    <div className="mt24 mb40">
      <input
        className="input01"
        placeholder={
          isFinalQuiz(answerData)
            ? "정답을 입력하세요."
            : "비밀번호를 입력하세요."
        }
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") handleSubmit();
        }}
      />

      <ButtonOnly
        btnValue={
          isLoading ? (
            <>
              <span className="btn-spinner white" />
            </>
          ) : (
            "입력 완료"
          )
        }
        btnClass={`inputBtn01 mt16 ${isActive ? "active" : ""}`}
        onFinish={handleSubmit}
        disabled={!isActive || isLoading}
      />
    </div>
  );
}

export default QuizeCheck;
